import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Button from "@material-ui/core/Button";
import { Grid, Paper, RadioGroup, Radio, FormControlLabel, TextField, InputAdornment, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import { useState } from "react";
import { ListadoSolicitudes } from "./ListadoSolicitudes";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SeleccionarFechaFin, SeleccionarFechaFinAuditoria, SeleccionarFechaInicio, SeleccionarFechaInicioAuditoria, SeleccionarIdSolicitud, setEstadosSolicitudes, TraerContadoresCotizaciones, TraerCotizaciones, TraerEstadosSolicitud, TraerListadoSolicitudes } from "../../../actions/compras/Cotizaciones";
import { ESTADOS_AUDITORIAFACTURACION_COMPRAS, ESTADOS_COTIZACIONES, TIPOS_AUTORIZACIONES } from "../../../utils/constants";
import { ListadoCotizaciones } from "./ListadoCotizaciones";
import { Search } from "@material-ui/icons";
import { ListadoComprobantes } from "../AuditoriaFacturacion/ListadoComprobantes";
import { SeleccionarIdSolicitudAuditoria, getComprobantes, getComprobantesPorEstado, getEstados, setEstadoFacturacion } from "../../../actions/compras/AuditoriaFactura";
import { ListadoComprobantesPorEstado } from "../AuditoriaFacturacion/ListadoComprobantesPorEstado";
import { AutorizacionesBuscador } from "../../autorizaciones/Ingreso/AutorizacionesBuscador";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import { useForm } from "../../../hooks/useForm";
import CloseIcon from '@material-ui/icons/Close';
import { cleanAfiliadoSeleccionado } from "../../../actions/autorizaciones/Autorizaciones";
import { COMPRAS_MENU_PERMISOS } from "../../../utils/permisos";
import { validarSoloUnPermiso } from "../../../helpers/permisos";
import { ModalCotizacionExpress } from "./ModalCotizacionExpress";
import { GestionPresupuestosHome } from "../../autorizaciones/gestionPresupuestos/GestionPresupuestosHome";
const useStyles = makeStyles({
    root: {
        flexGrow: 1
    },
    tabs: {
        marginTop: "1rem",
    },
    button: {
        textAlign: "center",
    },
    input: {
        // padding: 10,
        paddingLeft: 10,
        paddingRight: 10,
        marginTop: 9,
        marginLeft: 9
    },
});

const stateInitial = {
    idProfesional: null,
    fechaInicio: null,
    fechaFin: null,
    fechaInicioAuditoria: moment(),
    fechaFinAuditoria: moment(),
};

export const CotizacionesHome = () => {
    const classes = useStyles();
    const [menu, setMenu] = useState(0);
    const dispatch = useDispatch();
    const { permisos: permisosUser } = useSelector(state => state.auth);
    const { estadosSolicitud, estados, contadorEstadosCotizaciones, idSolicitudCompras } = useSelector((state) => state.compras);
    const { estadosFacturacion, estadosFacturacionSelect, contadorEstadosAuditoria } = useSelector((state) => state.auditoriaFacturacion);
    const { afiliadoSeleccionado } = useSelector((state) => state.autorizaciones);
    const [idSolicitud, setIdSolicitud] = useState(null);
    const [idSolicitudAuditoria, setIdSolicitudAuditoria] = useState(null);
    const [formValues, , , setearValor] = useForm(stateInitial);
    const { fechaInicio, fechaFin, fechaInicioAuditoria, fechaFinAuditoria } = formValues;
    const [cargaCotizacion, setCargaCotizacion] = useState(null);

    useEffect(() => {
        dispatch(SeleccionarFechaInicio(fechaInicio));
        dispatch(SeleccionarFechaFin(fechaFin));

    }, [dispatch, fechaFin, fechaInicio])


    useEffect(() => {
        dispatch(SeleccionarFechaInicioAuditoria(fechaInicioAuditoria));
        dispatch(SeleccionarFechaFinAuditoria(fechaFinAuditoria));

    }, [dispatch, fechaFinAuditoria, fechaInicioAuditoria])

    useEffect(() => {
        dispatch(TraerEstadosSolicitud());
        dispatch(getEstados());
        dispatch(cleanAfiliadoSeleccionado());
    }, [dispatch])

    useEffect(() => {
        dispatch(TraerContadoresCotizaciones(afiliadoSeleccionado?.id_afiliado, idSolicitudCompras, fechaInicio, fechaFin,
            menu === 1 ? TIPOS_AUTORIZACIONES.PRACTICAS : TIPOS_AUTORIZACIONES.MATERIALES_SIN_PRACTICAS
        ));
    }, [
        dispatch,
        estadosSolicitud,
        afiliadoSeleccionado?.id_afiliado,
        fechaInicio,
        fechaFin,
        menu])

    // useEffect(() => {
    //     dispatch(TraerContadoresAuditoria(afiliadoSeleccionado?.id_afiliado, idSolicitudAuditoria, fechaInicioAuditoria, fechaFinAuditoria));
    // }, [
    //     dispatch,
    //     estadosFacturacionSelect,
    //     afiliadoSeleccionado?.id_afiliado,
    //     fechaInicioAuditoria,
    //     fechaFinAuditoria])

    return (
        <div className={classes.root}>
            <Grid
                container
                spacing={1}
                direction="row"
                justify="center"
                alignItems="center"
            >
                {
                    cargaCotizacion &&
                    <ModalCotizacionExpress
                        open={cargaCotizacion}
                        close={() => setCargaCotizacion(false)}
                    />
                }
                <Grid item xs={12} styles={{ padding: 5 }}>
                    <Breadcrumbs style={{ color: "#FAFAFA" }} aria-label="breadcrumb">
                        {validarSoloUnPermiso(permisosUser, COMPRAS_MENU_PERMISOS.COMPRAS_ACCESO_SOLICITUDES) &&
                            <Button color={menu === 1 ? "default" : "inherit"}
                                onClick={() => { setMenu(1) }}>
                                <PlaylistAddCheckIcon />
                                Solicitudes de Prótesis Quirurgicas
                            </Button>
                        }
                        {validarSoloUnPermiso(permisosUser, COMPRAS_MENU_PERMISOS.COMPRAS_ACCESO_SOLICITUDES) &&
                            <Button color={menu === 3 ? "default" : "inherit"}
                                onClick={() => { setMenu(3) }}>
                                <PlaylistAddCheckIcon />
                                Solicitudes de Ortesis e Insumos
                            </Button>
                        }
                        {validarSoloUnPermiso(permisosUser, COMPRAS_MENU_PERMISOS.COMPRAS_ACCESO_AUDITORIA_FACTURAS) &&
                            <Button color={menu === 2 ? "default" : "inherit"}
                                onClick={() => { setMenu(2) }}>

                                <Search />
                                Auditoria Facturas
                            </Button>
                        }
                        {validarSoloUnPermiso(permisosUser, COMPRAS_MENU_PERMISOS.COMPRAS_ACCESO_PRESUPUESTOS) &&
                            <Button color={menu === 4 ? "default" : "inherit"}
                                onClick={() => { setMenu(4) }}>

                                <PlaylistAddCheckIcon />
                                Gestión de Presupuestos
                            </Button>
                        }
                    </Breadcrumbs>
                </Grid>

                {menu === 4 && (
                    <GestionPresupuestosHome fromCompras={true} />
                )}
                <Grid item xs={12}>
                    {menu === 1 && (
                        <>
                            <Grid style={{ display: "flex" }}>
                                <Grid item xs={12} md={6}>
                                    <AutorizacionesBuscador hideTitle={true} />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <Paper className={classes.input}>
                                        <TextField
                                            margin="normal"
                                            // InputProps={{ classes: { input: classes.NroAfi } }}
                                            fullWidth
                                            type='number'
                                            label="N° Orden"
                                            name="idSolicitud"
                                            value={idSolicitud}
                                            autoComplete="off"
                                            onChange={(e) => setIdSolicitud(e.target.value)}
                                            InputProps={{
                                                endAdornment:
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="Buscar"
                                                            onClick={() => {
                                                                dispatch(TraerCotizaciones(estadosSolicitud, afiliadoSeleccionado?.id_afiliado,
                                                                    idSolicitud, fechaInicio, fechaFin, TIPOS_AUTORIZACIONES.PRACTICAS));
                                                                dispatch(TraerListadoSolicitudes(afiliadoSeleccionado?.id_afiliado, idSolicitud,
                                                                    fechaInicio, fechaFin, TIPOS_AUTORIZACIONES.PRACTICAS));
                                                                dispatch(TraerContadoresCotizaciones(afiliadoSeleccionado?.id_afiliado, idSolicitud, fechaInicio,
                                                                    fechaFin, TIPOS_AUTORIZACIONES.PRACTICAS));
                                                                dispatch(SeleccionarIdSolicitud(idSolicitud));
                                                            }}
                                                        >
                                                            <Search />
                                                        </IconButton>
                                                    </InputAdornment>
                                            }}
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <Paper className={classes.input}>
                                        <Grid style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                                <KeyboardDatePicker
                                                    margin="normal"
                                                    label="Fecha Inicio"
                                                    format="dd/MM/yyyy"
                                                    // required={true}
                                                    clearLabel="Limpiar"
                                                    cancelLabel="Cancelar"
                                                    value={
                                                        moment(fechaInicio).isValid() ? moment(fechaInicio) : null
                                                    }
                                                    onChange={(date) => {
                                                        setearValor("fechaInicio", date);
                                                    }}
                                                    KeyboardButtonProps={{
                                                        "aria-label": "change date",
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>
                                            {fechaInicio && (
                                                <CloseIcon style={{ color: 'red', marginTop: '2.5rem' }} onClick={() => setearValor("fechaInicio", null)} />
                                            )}
                                        </Grid>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <Paper className={classes.input}>
                                        <Grid style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                                <KeyboardDatePicker
                                                    margin="normal"
                                                    label="Fecha Fin"
                                                    format="dd/MM/yyyy"
                                                    clearLabel="Limpiar"
                                                    cancelLabel="Cancelar"
                                                    value={moment(fechaFin).isValid() ? moment(fechaFin) : null}
                                                    onChange={(date) => {
                                                        setearValor("fechaFin", date);
                                                    }}
                                                    KeyboardButtonProps={{
                                                        "aria-label": "change date",
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>
                                            {fechaFin && (
                                                <CloseIcon style={{ color: 'red', marginTop: '2.5rem' }} onClick={() => setearValor("fechaFin", null)} />
                                            )}
                                        </Grid>
                                    </Paper>
                                </Grid>
                            </Grid>
                            <Paper style={{ padding: "1rem", margin: '0.5rem' }}>
                                <RadioGroup
                                    row
                                    style={{ justifyContent: "space-around" }}
                                    value={estadosSolicitud}
                                    onChange={(e) => { dispatch(setEstadosSolicitudes(e.target.value)) }}>

                                    {estados?.map((estadoSolicitud) => {
                                        const contador = contadorEstadosCotizaciones.find(x => x.idEstado === estadoSolicitud.idEstado);
                                        const label =
                                            ((contador /*&& contador.total !== 0*/)
                                                ?
                                                `(${contador.total})`
                                                :
                                                `(...)`
                                            );
                                        return (
                                            <FormControlLabel
                                                key={estadoSolicitud.idEstado.toString()}
                                                label={estadoSolicitud.descripcionEstado + " " + label}
                                                value={estadoSolicitud.idEstado.toString()}
                                                control={<Radio />}
                                                style={{ marginLeft: "0.5rem" }}
                                            />);
                                    })}
                                </RadioGroup>
                            </Paper>
                        </>
                    )}


                    {menu === 3 && (
                        <>
                            <Grid style={{ display: "flex" }}>
                                <Grid item xs={12} md={6}>
                                    <AutorizacionesBuscador hideTitle={true} />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <Paper className={classes.input}>
                                        <TextField
                                            margin="normal"
                                            // InputProps={{ classes: { input: classes.NroAfi } }}
                                            fullWidth
                                            type='number'
                                            label="N° Orden"
                                            name="idSolicitud"
                                            value={idSolicitud}
                                            autoComplete="off"
                                            onChange={(e) => setIdSolicitud(e.target.value)}
                                            InputProps={{
                                                endAdornment:
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="Buscar"
                                                            onClick={() => {
                                                                dispatch(TraerCotizaciones(estadosSolicitud, afiliadoSeleccionado?.id_afiliado, idSolicitud, null, null, TIPOS_AUTORIZACIONES.MATERIALES_SIN_PRACTICAS));
                                                                dispatch(TraerListadoSolicitudes(afiliadoSeleccionado?.id_afiliado, idSolicitud,
                                                                    null, null, TIPOS_AUTORIZACIONES.MATERIALES_SIN_PRACTICAS));
                                                                dispatch(TraerContadoresCotizaciones(afiliadoSeleccionado?.id_afiliado, idSolicitud, fechaInicio,
                                                                    fechaFin, TIPOS_AUTORIZACIONES.MATERIALES_SIN_PRACTICAS));
                                                                dispatch(SeleccionarIdSolicitud(idSolicitud));
                                                            }}
                                                        >
                                                            <Search />
                                                        </IconButton>
                                                    </InputAdornment>
                                            }}
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <Paper className={classes.input}>
                                        <Grid style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                                <KeyboardDatePicker
                                                    margin="normal"
                                                    label="Fecha Inicio"
                                                    format="dd/MM/yyyy"
                                                    // required={true}
                                                    clearLabel="Limpiar"
                                                    cancelLabel="Cancelar"
                                                    value={
                                                        moment(fechaInicio).isValid() ? moment(fechaInicio) : null
                                                    }
                                                    onChange={(date) => {
                                                        setearValor("fechaInicio", date);
                                                    }}
                                                    KeyboardButtonProps={{
                                                        "aria-label": "change date",
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>
                                            {fechaInicio && (
                                                <CloseIcon style={{ color: 'red', marginTop: '2.5rem' }} onClick={() => setearValor("fechaInicio", null)} />
                                            )}
                                        </Grid>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <Paper className={classes.input}>
                                        <Grid style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                                <KeyboardDatePicker
                                                    margin="normal"
                                                    label="Fecha Fin"
                                                    format="dd/MM/yyyy"
                                                    clearLabel="Limpiar"
                                                    cancelLabel="Cancelar"
                                                    value={moment(fechaFin).isValid() ? moment(fechaFin) : null}
                                                    onChange={(date) => {
                                                        setearValor("fechaFin", date);
                                                    }}
                                                    KeyboardButtonProps={{
                                                        "aria-label": "change date",
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>
                                            {fechaFin && (
                                                <CloseIcon style={{ color: 'red', marginTop: '2.5rem' }} onClick={() => setearValor("fechaFin", null)} />
                                            )}
                                        </Grid>
                                    </Paper>
                                </Grid>
                            </Grid>
                            <Paper style={{ padding: "1rem", margin: '0.5rem' }}>
                                <RadioGroup
                                    row
                                    style={{ justifyContent: "space-around" }}
                                    value={estadosSolicitud}
                                    onChange={(e) => { dispatch(setEstadosSolicitudes(e.target.value)) }}>

                                    {estados?.map((estadoSolicitud) => {
                                        const contador = contadorEstadosCotizaciones.find(x => x.idEstado === estadoSolicitud.idEstado);
                                        const label =
                                            ((contador /*&& contador.total !== 0*/)
                                                ?
                                                `(${contador.total})`
                                                :
                                                `(...)`
                                            );
                                        return (
                                            <FormControlLabel
                                                key={estadoSolicitud.idEstado.toString()}
                                                label={estadoSolicitud.descripcionEstado + " " + label}
                                                value={estadoSolicitud.idEstado.toString()}
                                                control={<Radio />}
                                                style={{ marginLeft: "0.5rem" }}
                                            />);
                                    })}
                                </RadioGroup>
                            </Paper>
                        </>
                    )}
                    {menu === 2 && (
                        <>
                            <Grid style={{ display: "flex" }}>
                                <Grid item xs={12} md={6}>
                                    <AutorizacionesBuscador hideTitle={true} />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <Paper className={classes.input}>
                                        <TextField
                                            margin="normal"
                                            // InputProps={{ classes: { input: classes.NroAfi } }}
                                            fullWidth
                                            type='number'
                                            label="N° Orden"
                                            name="idSolicitudAuditoria"
                                            value={idSolicitudAuditoria}
                                            autoComplete="off"
                                            onChange={(e) => setIdSolicitudAuditoria(e.target.value)}
                                            InputProps={{
                                                endAdornment:
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="Buscar"
                                                            onClick={() => {
                                                                dispatch(getComprobantes(
                                                                    afiliadoSeleccionado?.id_afiliado,
                                                                    idSolicitudAuditoria,
                                                                    moment(fechaInicioAuditoria).startOf('days'),
                                                                    moment(fechaFinAuditoria).endOf('days')
                                                                ));
                                                                dispatch(getComprobantesPorEstado(
                                                                    estadosFacturacionSelect,
                                                                    afiliadoSeleccionado?.id_afiliado,
                                                                    idSolicitudAuditoria,
                                                                    moment(fechaInicioAuditoria).startOf('days'),
                                                                    moment(fechaFinAuditoria).endOf('days')
                                                                ))
                                                                dispatch(SeleccionarIdSolicitudAuditoria(idSolicitudAuditoria));
                                                            }}
                                                        >
                                                            <Search />
                                                        </IconButton>
                                                    </InputAdornment>
                                            }}
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <Paper className={classes.input}>
                                        <Grid style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                                <KeyboardDatePicker
                                                    margin="normal"
                                                    label="Fecha Inicio"
                                                    format="dd/MM/yyyy"
                                                    // required={true}
                                                    clearLabel="Limpiar"
                                                    cancelLabel="Cancelar"
                                                    value={
                                                        moment(fechaInicioAuditoria).isValid() ? moment(fechaInicioAuditoria) : null
                                                    }
                                                    onChange={(date) => {
                                                        setearValor("fechaInicioAuditoria", date);
                                                    }}
                                                    KeyboardButtonProps={{
                                                        "aria-label": "change date",
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>
                                            {fechaInicioAuditoria && (
                                                <CloseIcon style={{ color: 'gray', marginTop: '2.5rem' }} onClick={() => setearValor("fechaInicioAuditoria", moment())} />
                                            )}
                                        </Grid>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <Paper className={classes.input}>
                                        <Grid style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                                <KeyboardDatePicker
                                                    margin="normal"
                                                    label="Fecha Fin"
                                                    format="dd/MM/yyyy"
                                                    clearLabel="Limpiar"
                                                    cancelLabel="Cancelar"
                                                    value={moment(fechaFinAuditoria).isValid() ? moment(fechaFinAuditoria) : null}
                                                    onChange={(date) => {
                                                        setearValor("fechaFinAuditoria", date);
                                                    }}
                                                    KeyboardButtonProps={{
                                                        "aria-label": "change date",
                                                    }}
                                                />
                                            </MuiPickersUtilsProvider>
                                            {fechaFinAuditoria && (
                                                <CloseIcon style={{ color: 'gray', marginTop: '2.5rem' }} onClick={() => setearValor("fechaFinAuditoria", moment())} />
                                            )}
                                        </Grid>
                                    </Paper>
                                </Grid>
                            </Grid>
                            <Paper style={{ padding: "1rem", margin: '0.5rem' }}>
                                <RadioGroup
                                    row
                                    style={{ justifyContent: "space-around" }}
                                    value={estadosFacturacionSelect}
                                    onChange={(e) => { dispatch(setEstadoFacturacion(e.target.value)) }}>

                                    {estadosFacturacion?.map((estadoFacturacion) => {
                                        const contador = contadorEstadosAuditoria.find(x => x.idEstado === estadoFacturacion.idEstadoTramite);
                                        const labelAuditoria =
                                            ((contador /*&& contador.total !== 0*/)
                                                ?
                                                `(${contador.total})`
                                                :
                                                `(...)`
                                            );


                                        return (
                                            <FormControlLabel
                                                key={estadoFacturacion.idEstadoTramite.toString()}
                                                label={estadoFacturacion.descripcionEstadoTramite + " " + labelAuditoria}
                                                value={estadoFacturacion.idEstadoTramite.toString()}
                                                control={<Radio />}
                                                style={{ marginLeft: "0.5rem" }}
                                            />);
                                    })}
                                </RadioGroup>
                            </Paper>
                        </>
                    )}

                    {(menu === 1 || menu === 3) && (
                        <Paper style={{ padding: "0.5rem", margin: '0.3rem', textAlign: 'center' }}>
                            <Button color="primary" variant="contained" onClick={() => setCargaCotizacion(true)}>Agregar Cotizacion</Button>
                        </Paper>)}
                    <Grid
                        container
                        justify="center"
                        className={classes.root}
                    >
                        {Number(estadosSolicitud) === ESTADOS_COTIZACIONES.PENDIENTE_COTIZACION && menu === 1 && (
                            <ListadoSolicitudes idTipoSolicitud={TIPOS_AUTORIZACIONES.PRACTICAS} />
                        )}
                        {Number(estadosSolicitud) === ESTADOS_COTIZACIONES.PENDIENTE_COTIZACION && menu === 3 && (
                            <ListadoSolicitudes idTipoSolicitud={TIPOS_AUTORIZACIONES.MATERIALES_SIN_PRACTICAS} />
                        )}
                    </Grid>
                    <Grid>
                        {
                            (Number(estadosSolicitud) === ESTADOS_COTIZACIONES.COTIZACIONES_ACEPTADAS ||
                                Number(estadosSolicitud) === ESTADOS_COTIZACIONES.COTIZACIONES_SOLICITADAS ||
                                Number(estadosSolicitud) === ESTADOS_COTIZACIONES.PENDIENTE_ACEPTACION ||
                                Number(estadosSolicitud) === ESTADOS_COTIZACIONES.ANULADAS
                            )
                            && menu === 1 && (
                                <ListadoCotizaciones idTipoSolicitud={TIPOS_AUTORIZACIONES.PRACTICAS} menu={menu} />
                            )

                        }
                    </Grid>
                    <Grid>
                        {
                            (Number(estadosSolicitud) === ESTADOS_COTIZACIONES.COTIZACIONES_ACEPTADAS ||
                                Number(estadosSolicitud) === ESTADOS_COTIZACIONES.COTIZACIONES_SOLICITADAS ||
                                Number(estadosSolicitud) === ESTADOS_COTIZACIONES.PENDIENTE_ACEPTACION ||
                                Number(estadosSolicitud) === ESTADOS_COTIZACIONES.ANULADAS)
                            && menu === 3 && (
                                <ListadoCotizaciones idTipoSolicitud={TIPOS_AUTORIZACIONES.MATERIALES_SIN_PRACTICAS} menu={menu} />
                            )

                        }
                    </Grid>
                    <Grid>
                        {
                            menu === 2 && Number(estadosFacturacionSelect) === ESTADOS_AUDITORIAFACTURACION_COMPRAS.COMPROBANTE && (
                                <ListadoComprobantes />
                            )
                        }
                    </Grid>
                    <Grid>
                        {
                            (Number(estadosFacturacionSelect) === ESTADOS_AUDITORIAFACTURACION_COMPRAS.PENDIENTE_ENVIO ||
                                Number(estadosFacturacionSelect) === ESTADOS_AUDITORIAFACTURACION_COMPRAS.PENDIENTE_PAGO ||
                                Number(estadosFacturacionSelect) === ESTADOS_AUDITORIAFACTURACION_COMPRAS.RECHAZADAS ||
                                Number(estadosFacturacionSelect) === ESTADOS_AUDITORIAFACTURACION_COMPRAS.PAGADAS) &&
                            menu === 2 &&
                            (
                                <ListadoComprobantesPorEstado />
                            )
                        }
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}